/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Layout } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import VendorPolicyService from '../../../services/VendorPolicy.service';
import IconEmpty from '../../../assets/Images/icons/empty';
import { ROUTER } from '../../../constants/router';
import ListPrivacy from '../Shared/ListPrivacy';
import useNotify from '../../../context/Notification/useNotify';
import { useForm } from 'antd/lib/form/Form';
import DocTabs from './component/DocTabs';
import { usePreviewtoString } from './component/PreviewToString';
import { PlusOutlined } from '@ant-design/icons';
import GlobalService from '../../../services/Global.service';
import { calculateImageWidth } from '../../../util/util';
import usePermission from '../../../hooks/usePermission';

export default function VenderPrivacyPolicy({ selectType }) {
    const { t, i18n } = useTranslation(['translation', 'hr-policy']);
    let lang = i18n.language;
    const [data, setData] = useState([]);
    const [currentSelectList, setCurrentSelectList] = useState();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(false);
    const [detailPublished, setDetailPublished] = useState();

    let navigate = useNavigate();
    // Logo
    const [logo, setLogo] = useState('');
    const [logoPublish, setLogoPublish] = useState('');
    const getImage = async (companyLogoId) => {
        try {
            const { data } = await GlobalService.getImage(companyLogoId);
            if (data.resultData?.imageId) {
                return `data:image/png;base64,${data.resultData?.imageId}`;
            }
        } catch (error) {
            setLogo('');
            setLogoPublish('');
            console.log(error);
        }
    };

    const getPolicyList = async () => {
        const { data } = await VendorPolicyService.searchVendorPolicy(
            selectType ? selectType : ''
        );
        if (data?.resultData) {
            setData(data.resultData);
            setCurrentSelectList(data.resultData[0]);
        }
    };

    const getPublishedVersion = async () => {
        try {
            const { data } = await VendorPolicyService.getPublishedVersion(
                currentSelectList?.vendorPrivacyPolicyNoticeId
            );
            if (data?.resultData) {
                const parse = JSON.parse(data?.resultData?.data);
                setDetailPublished(parse);
                // Logo
                setLogoPublish('');
                if (parse?.vendorPrivacyPolicy?.vendorCompanyLogoId) {
                    getImage(
                        parse?.vendorPrivacyPolicy?.vendorCompanyLogoId
                    ).then((logo) => setLogoPublish(logo));
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const getVendorPolicyDetail = async () => {
            try {
                const { data } =
                    await VendorPolicyService.getVendorPolicyDetail(
                        currentSelectList?.vendorPrivacyPolicyNoticeId
                    );
                if (data?.resultData) {
                    setDetail(data?.resultData);
                    setLoading(false);
                    // Logo
                    setLogo('');
                    if (
                        data?.resultData?.vendorPrivacyPolicy
                            ?.vendorCompanyLogoId
                    ) {
                        getImage(
                            data?.resultData?.vendorPrivacyPolicy
                                ?.vendorCompanyLogoId
                        ).then((logo) => setLogo(logo));
                    }
                } else {
                    setLoading(false);
                }
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        };

        if (currentSelectList?.vendorPrivacyPolicyNoticeId)
            getVendorPolicyDetail();
        if (
            currentSelectList?.hasChanged &&
            currentSelectList?.status === 'Published'
        )
            getPublishedVersion();
        else setDetailPublished();
    }, [currentSelectList?.vendorPrivacyPolicyNoticeId]);

    useEffect(() => {
        getPolicyList();
        // setData(mockData?.resultData);
        // setCurrentSelectList(mockData?.resultData[0]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectType]);

    const notify = useNotify();
    const [form] = useForm();

    const handelRename = (values) => {
        if (currentSelectList?.vendorPrivacyPolicyNoticeId) {
            const payload = {
                vendorPrivacyPolicyId:
                    currentSelectList?.vendorPrivacyPolicyNoticeId,
                vendorPrivacyPolicyNameTh: values.nameTh,
                vendorPrivacyPolicyNameEn: values.nameEn,
            };
            setLoading(true);
            setTimeout(async () => {
                try {
                    const { data } = await VendorPolicyService.rename(payload);
                    if (data.resultCode === 1) {
                        form.resetFields();
                        notify({
                            title: t('common.Success'),
                            description: t('Successfully saved data'),
                            timeOut: 1800,
                        });
                        setTimeout(() => {
                            setLoading(false);
                            getPolicyList();
                        }, 1300);
                    } else {
                        setLoading(false);
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to rename'),
                        });
                    }
                } catch (error) {
                    setLoading(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to rename'),
                    });
                }
            }, 1000);
        }
    };

    const width1 = calculateImageWidth(logo);
    const width2 = calculateImageWidth(logoPublish);
    const { html } = usePreviewtoString(detail, 'TH', logo, width1);
    const { html: htmlEn } = usePreviewtoString(detail, 'EN', logo, width1);

    const { html: htmlPublish } = usePreviewtoString(
        detailPublished,
        'TH',
        logoPublish,
        width2
    );
    const { html: htmlPublishEn } = usePreviewtoString(
        detailPublished,
        'EN',
        logoPublish,
        width2
    );

    const { isAuditor } = usePermission();

    return (
        <Layout>
            <div className="flex items-center my-4">
                <div className="flex-1 font-bold text-xl">
                    {t('Vendor Privacy Policy list', {
                        ns: 'hr-policy',
                    })}
                </div>
                <Button
                    disabled={isAuditor}
                    type="primary"
                    size="large"
                    onClick={() => {
                        navigate(`${ROUTER.POLICY.VENDOR_PRIVACY}/new#step1`);
                    }}
                    icon={<PlusOutlined />}
                >
                    {t('Add Policy')}
                </Button>
            </div>
            {true ? (
                <div className="grid grid-cols-7 gap-4">
                    <ListPrivacy
                        data={data}
                        pathEdit={ROUTER.POLICY.VENDOR_PRIVACY}
                        stepEdit={'#step9'} // step preview
                        currentSelectName={{
                            nameTh: detail?.vendorPrivacyPolicy
                                ?.vendorPrivacyPolicyNameTh,
                            nameEn: detail?.vendorPrivacyPolicy
                                ?.vendorPrivacyPolicyNameEn,
                            namePublishTh:
                                detailPublished?.vendorPrivacyPolicy
                                    ?.vendorPrivacyPolicyNameTh,
                            namePublishEn:
                                detailPublished?.vendorPrivacyPolicy
                                    ?.vendorPrivacyPolicyNameEn,
                            placeholderNameEN: t('PlaceholderNameEN', {
                                ns: 'hr-policy',
                            }),
                            placeholderNameTH: t('PlaceholderNameTH', {
                                ns: 'hr-policy',
                            }),
                        }}
                        setCurrentSelectList={setCurrentSelectList}
                        currentSelectList={currentSelectList}
                        form={form}
                        // Parameters Name
                        policyObject={{
                            privacyName:
                                lang === 'en'
                                    ? 'vendorPrivacyPolicyNoticeNameEn'
                                    : 'vendorPrivacyPolicyNoticeNameTh',
                            nameTh: 'vendorPrivacyPolicyNoticeNameTh',
                            nameEn: 'vendorPrivacyPolicyNoticeNameEn',
                            privacyType:
                                lang === 'en'
                                    ? 'vendorPrivacyPolicyTypeEn'
                                    : 'vendorPrivacyPolicyTypeTh',
                            privacyId: 'vendorPrivacyPolicyNoticeId',
                            privacyCompany:
                                lang === 'en'
                                    ? 'vendorCompanyNameEn'
                                    : 'vendorCompanyNameTh',
                        }}
                        handelRename={(value) => handelRename(value)}
                        loading={loading}
                        linkName="external-vendor-privacy"
                        getPolicyList={getPolicyList}
                        historyObject={{
                            type: 'vendor',
                            serviceHistory: VendorPolicyService.getHistories,
                            historyParamName: 'vendorPrivacyPolicyId', // ชื่อ payload ของ id ที่ service get history เช่น hrPrivacyPolicyId: "1234" ที่ต้องใส่คือ: hrPrivacyPolicyId
                            historyResultIdName: 'vendorPrivacyPolicyHistoryId', // ได้หลังจาก service get history ใน result ชื่อ parameter ของ id เช่น { "hrPrivacyPolicyHistoryId" : 1234 } ที่ต้องใส่คือ: hrPrivacyPolicyHistoryId
                        }}
                        // pop up ของ confirm ก่อน delete
                        confirmObject={{
                            title:
                                lang === 'en'
                                    ? 'There may be websites that use this vendor privacy policy.'
                                    : 'อาจมีเว็บไซต์ใช้นโยบายความเป็นส่วนตัวใน\nกระบวนการจัดซื้อจัดจ้างนี้อยู่',
                            text:
                                lang === 'en'
                                    ? `Before deleting the data, please check that no website is using this vendor privacy policy.`
                                    : `ก่อนลบข้อมูล โปรดตรวจสอบว่าไม่มีเว็บไซต์ใดใช้\nนโยบายความเป็นส่วนตัวในกระบวนการจัดซื้อจัดจ้างนี้`,
                        }}
                        // pop up ของ delete
                        deleteObject={{
                            serviceDelete:
                                VendorPolicyService?.deleteVendorPolicy,
                            title:
                                currentSelectList?.status === 'Draft'
                                    ? t('ModalTitleDeleteDraft', {
                                          ns: 'hr-policy',
                                      })
                                    : t('ModalTitleDeleteDraft', {
                                          ns: 'hr-policy',
                                      }),
                            text:
                                currentSelectList?.status === 'Draft'
                                    ? `${t('ModalDeleteDraft', {
                                          version: currentSelectList?.version,
                                          ns: 'hr-policy',
                                      })}`
                                    : `${t('ModalVendorDetailDeletePublish', {
                                          ns: 'hr-policy',
                                      })} \n${t('ModalDeletePublish', {
                                          version:
                                              currentSelectList?.latestPublishVersion,
                                          ns: 'hr-policy',
                                      })}`,
                        }}
                        templateBody={{
                            html,
                            htmlEn,
                            htmlPublish,
                            htmlPublishEn,
                        }}
                    >
                        {(previewLang) => (
                            <DocTabs
                                logo={logo}
                                logoPublish={logoPublish}
                                detail={detail}
                                loading={loading}
                                currentSelectList={currentSelectList}
                                previewLang={previewLang}
                                privacyPolicyNoticeId={
                                    currentSelectList?.vendorPrivacyPolicyNoticeId
                                }
                                detailPublished={detailPublished}
                            />
                        )}
                    </ListPrivacy>
                </div>
            ) : (
                <div className="grid items-center justify-center mt-20">
                    <IconEmpty />
                </div>
            )}
        </Layout>
    );
}
